<template>
  <div id="galleryGuestPurchaseSuccess" aria-hidden="true"
       class="modal modal--rebrand fade over-all modal-with-custom-content modal-with-custom-content--dark-background"
       data-backdrop="static" data-keyboard="false"
       role="dialog" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <button aria-label="Close" class="close gallery-success-close" data-dismiss="modal" type="button">
          <span aria-hidden="true">&times;</span>
        </button>
        <div v-if="galleryDetails"
             class="modal-body d-flex flex-column justify-content-center align-items-center modal-guest-gallery modal-guest-gallery--success"
        >
          <span class="text-size-big mb-2">{{ translate.home.guestGallery.contentUnlocked }}</span>
          <span class="text-small text-center">
            <span v-html="fillTranslateParams(
                   translate.home.guestGallery.congratulations,
                  {
                    username: galleryDetails.username,
                    photos: galleryDetails.photoQuantity,
                    videos: galleryDetails.videoQuantity,
                  }
               )"></span>
          </span>

          <template v-if="code">
            <span class="gallery-code-description">
              <span class="text-center d-block" v-html="fillTranslateParams(translate.home.guestGallery.hereIsYourCode, {days:galleryDetails.prices[0].days})"></span>
            </span>
            <span class="gallery-code">{{ code }}</span>
          </template>

          <template v-if="subscriptionId && !emailSubmitted">
            <div class="gallery-code-email-prompt mt-4 w-100 text-center px-3">
              <p class="text-small">{{ translate.home.guestGallery.saveCodePrompt }}</p>
              <input v-model="email"
                     :disabled="emailSubmitting"
                     :placeholder="translate.home.guestGallery.emailPlaceholder"
                     class="form-control gallery-code-email-input"
                     type="email">
              <span v-if="emailError" class="text-danger text-small mt-1 d-block">{{ emailError }}</span>
              <button-with-loading-component
                  :loading="emailSubmitting"
                  :disabled="emailSubmitting || !email"
                  @click.native.prevent="submitEmail"
                  class="btn btn-rebrand-primary btn-rebrand-sm w-100 mt-3"
                  :text="translate.home.guestGallery.saveCodeButton"
              />
            </div>
          </template>
          <template v-else-if="emailSubmitted">
            <p class="text-small mt-4">{{ translate.home.guestGallery.saveCodeSuccess }}</p>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import userMixin from "@/components/mixins/userMixin";
import PunterRegistrationComponent from "@/components/users/auth/PunterRegistrationComponent";
import PunterLoginComponent from "@/components/users/auth/PunterLoginComponent";
import privateGalleriesMixin from "@/components/mixins/gallery/privateGalleriesMixin";
import ButtonWithLoadingComponent from "@/components/global/ButtonWithLoadingComponent";
import translateMixin from "@/components/mixins/translateMixin";
import api from "@/core/api/index.js";

const data = () => {
  return {
    galleryDetails: null,
    code: null,
    subscriptionId: null,
    email: '',
    emailSubmitting: false,
    emailSubmitted: false,
    emailError: null,
  };
};

function initModal(details, code, subscriptionId = null) {
  this.galleryDetails = details;
  this.code = code;
  this.subscriptionId = subscriptionId;
  this.email = '';
  this.emailSubmitting = false;
  this.emailSubmitted = false;
  this.emailError = null;

  this.showModalWhenReady();
}

function showModalWhenReady() {
  const element = $('#galleryGuestPurchaseSuccess');
  if (element.length && typeof element.modal === 'function') {
    element.modal('show');
    return;
  }
  setTimeout(() => this.showModalWhenReady(), 100);
}

async function submitEmail() {
  if (!this.email || this.emailSubmitting) {
    return;
  }

  this.emailSubmitting = true;
  this.emailError = null;

  const [err] = await to(api.gallery.guest.saveEmail(this.subscriptionId, this.code, this.email));

  this.emailSubmitting = false;

  if (err) {
    const fallback = this.translate.home.guestGallery.saveCodeError;
    const messageOrFallback = _.get(err, 'response.data.message', fallback);
    this.emailError = _.get(err, 'response.data.errors.email.0', messageOrFallback);
    return;
  }

  this.emailSubmitted = true;
}

export default {
  components: {ButtonWithLoadingComponent, PunterLoginComponent, PunterRegistrationComponent},
  data,
  methods: {
    initModal,
    showModalWhenReady,
    submitEmail,
  },
  mixins: [userMixin, privateGalleriesMixin, translateMixin,],
  beforeDestroy() {
    window.clearModalFade();
  },
};
</script>
